export default "__VITE_ASSET__Cux7l6rC__"